
<div>
  <div v-if="customSize" class="flex flex-col gap-5">
    <img src="@/images/get-quote-modal/conditions/phone-call.png" alt="Phone call">
    <h3 class="custom-size-h3">
      You've opted for a Custom Size Container
    </h3>
    <p class="custom-size-p">
      A sales rep will reach out
      to finish your quote.
    </p>
  </div>
  <fieldset v-else class="fieldset">
    <div class="field">
      <div class="control radio-list">
        <a 
          v-for="(label, value) in stepOptions" 
          :key="value" 
          @click="chooseCondition(value)" 
          :class="['h-[138px] lg:h-[80px] rounded-lg px-4 py-3 flex flex-col lg:flex-row justify-between mb-3 hover:shadow transition-all', 
            updates.condition == value ? 'bg-[#EEF4FF] border-2 border-[#4D84FF]' : 'bg-white border border-[#EDE9E3]']"
        >
          <div class="w-[75%] flex items-center gap-2">
            <img class="h-[48px] w-[48px] border-2 border-[#EDE9E3] rounded-full" :src="'/images/'+value+'.png'" />
            <span class="condition-title">{{ label }}</span>
          </div>
          <div class="w-full flex justify-between items-center">
            <div class="flex flex-col">
              <span class="condition-status-label">Longevity</span>
              <div class="flex pl-1">
                <img src="@/images/get-quote-modal/conditions/longenvity.svg" alt="Longenvity">
                <p class="condition-status-label">{{  rates(value) }}</p>
              </div>
            </div>
            <div class="h-[16px] border border-[#D4CBBF]"></div>
            <div class="flex flex-col">
              <span class="condition-status-label">Cost</span>
              <div class="flex pl-1">
                <img src="@/images/get-quote-modal/conditions/cost.svg" alt="Cost">
                <p class="condition-status-label">{{ rates(value) }}</p>
              </div>
            </div>
            <div class="h-[16px] border border-[#D4CBBF]"></div>
            <div class="flex flex-col">
              <span class="condition-status-label">Condition</span>
              <div class="flex pl-1">
                <img src="@/images/get-quote-modal/conditions/condition.svg" alt="Condition">
                <p class="condition-status-label">{{ rates(value, 'condition') }}</p>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </fieldset>
</div>
